import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LessonsIconV2 = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Lessons Icon V2`} {...props}>
    <Path
      fill="#001A19"
      d="m0 5.143 8-4 8 4v6.285h-1.143V5.714L8 9.143l-8-4Z"
    />
    <Path
      fill="#001A19"
      d="M8 10.857 13.143 8v4L8 14.857 2.857 12V8L8 10.857Z"
    />
  </Icon>
);
